/*
    Imports the Roast API URL from the config.
*/

import apiCtrl from '@/services/api/abstract/abstract-api.js';
export default {
  threadPostMessageUrl: function(id) {
    return apiCtrl.getBaseUrl() + '/thread/' + id + '/message';
  },

  getThreadSearchPaginate: function(params) {
    let searchParams = {};
    const defaultParams = {
      search: {},
      page: null,
      searchField: null,
      filter: null,
      operator: 'OR',
      orderBy: null,
      sortedBy: null,
      searchJoin: 'or',
    };

    for (const param in params) {
      if (params.hasOwnProperty(param)) {
        const value = params[param];
        if (value) {
          searchParams[param] = value;
        }
      }
    }

    searchParams = Object.assign({}, defaultParams, searchParams);
    return apiCtrl.get('/thread/all', {
      params: searchParams,
    });
  },

  /*
        GET     /api/v1/threads
    */
  getThreads: function() {
    return apiCtrl.get('/thread/all');
  },
  /*
        GET     /api/v1/threads
    */
  getActiveThreads: function() {
    let config = {};
    config.params = {
      search: 'active',
      searchField: 'status',
    };
    return apiCtrl.get('/thread/all', config);
  },

  /*
        GET     /api/v1/threads
    */
  getClosedThreads: function() {
    let config = {};
    config.params = {
      search: 'closed',
      searchField: 'status',
    };
    return apiCtrl.get('/thread');
  },

  /*
        GET     /api/v1/threads/{threadID}
    */
  getThread: function(threadID) {
    return apiCtrl.get('/thread/' + threadID);
  },

  /*
        POST    /api/v1/threads
    */
  postThread: function(data) {
    return apiCtrl.post('/thread', data);
  },

  postMessage: function(data) {
    return apiCtrl.post('/thread/' + data.thread + '/message', {
      message: data.message,
      attached: data.attached ? data.attached : '',
    });
  },

  deleteThread: function(id) {
    return apiCtrl.delete('/thread/' + id);
  },

  deleteMessage: function(id) {
    return apiCtrl.delete('/message/' + id);
  },

  changeThreadStatus: function(id, status, config = {}) {
    return apiCtrl.post(
      '/thread-status/' + id,
      {
        status: status,
      },
      config,
    );
  },
  changeThreadRead: function(id, read, config = {}) {
    return apiCtrl.post(
      '/thread-read/' + id,
      {
        read: read,
      },
      config,
    );
  },
  changeThreadReadByCustomer: function(id, read, config = {}) {
    return apiCtrl.post(
      '/thread-read-customer/' + id,
      {
        read_by_customer: read,
      },
      config,
    );
  },
  changeThreadCategory: function(id, categoryValue, categoryName, config = {}) {
    return apiCtrl.post(
      '/thread-category/' + id,
      {
        categoryValue: categoryValue,
        categoryName: categoryName,
      },
      config,
    );
  },
};
